module.exports = __webpack_public_path__ + "img/emitFacefilter01.48442e71.png";